import React, { useState, useEffect } from "react";
import { Box, IconButton } from "@mui/material";
// import FileViewer from "react-file-viewer";
import "./excelOutput.scss";
import { useDispatch, useSelector } from "react-redux";
import * as acts from "../../redux/investigation/actions";
import Progressbar from "../../components/ProgressBar";
import { Document, Page, pdfjs } from "react-pdf";
// import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// import "react-pdf/dist/esm/Page/TextLayer.css";

import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import XlsxCsvViewer from "./xlsxViewer";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const Index = ({ dialogData, handleDialogClose, isViewOnly }) => {
  const data = dialogData;
  const [isLoader, setIsLoader] = useState();

  const Dispatch = useDispatch();

  const outPutUrl = useSelector((state) => state?.investigation?.outPutUrl);

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    setIsLoader(true);
    Dispatch(acts.getOutPutUrl(data?.id));

    setTimeout(() => {
      setIsLoader(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outPutUrl?.filePath]);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <>
      <Box className="PdfOutput-wrap">
        <Box className="PdfOutput-container">
          <p>{data?.project_name + " / " + data?.batch_name}</p>
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      <Box className={isViewOnly ? "xlsx-wrap-fullheight" : "xlsx-wrap"}>
        {isLoader ? (
          <Progressbar />
        ) : (
          <>
            {outPutUrl?.file_type === "xlsx" ||
            outPutUrl?.file_type === "csv" ? (
              <div className="xlsx-fileViewer">
                <XlsxCsvViewer filePath={outPutUrl?.file_path} />
                {/* <FileViewer
                  fileType={outPutUrl?.file_type}
                  filePath={outPutUrl?.file_path}
                  errorComponent={"error"}
                /> */}
              </div>
            ) : (
              <div>
                <Box className="pagination">
                  <div className="p-sticky">
                    <label className="paginationLabel">Page {pageNumber}</label>
                    <IconButton
                      aria-label="left"
                      onClick={() =>
                        pageNumber === 1 ? "" : setPageNumber(pageNumber - 1)
                      }
                      disabled={pageNumber === 1}
                    >
                      <ChevronLeftIcon />
                    </IconButton>
                    <IconButton
                      aria-label="right"
                      onClick={() => setPageNumber(pageNumber + 1)}
                      disabled={pageNumber === numPages}
                    >
                      <ChevronRightIcon />
                    </IconButton>
                  </div>
                </Box>

                <div>
                  <Box style={{ padding: "35px 0px" }}>
                    <Document
                      file={outPutUrl?.file_path}
                      onLoadSuccess={onDocumentLoadSuccess}
                      renderMode="canvas"
                      className="custom-pdf-document"
                    >
                      <Page pageNumber={pageNumber} />
                    </Document>
                  </Box>
                </div>
              </div>
            )}
          </>
        )}
      </Box>
    </>
  );
};

export default Index;
